import PropTypes from "prop-types";
import React, { useMemo } from "react";
// arco
import { Layout, Button } from "@arco-design/web-react";
import { IconMenu } from '@arco-design/web-react/icon';
// hooks
import { useResponsive } from "src/hooks/use-responsive";
//
import { AccountPopover, BalanceDisplay } from "src/layouts/_common";
import Image from "src/components/image";
//

// ----------------------------------------------------------------------

export default function Header({ onOpenNav }) {

    const lgUp = useResponsive("up", "lg");

    const renderContent = useMemo(() => (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <div size={12} style={{ display: 'inline-flex', alignItems: 'center', height: 30, gap: 12 }}>
                {!lgUp && (
                    <Button type="text" onClick={onOpenNav} style={{ padding: 4 }} icon={<IconMenu style={{ color: "#4E5969" }} />} />
                )}
                <Image src="/assets/icon/auth/ic_full_logo.svg" alt="HIHISHIP_logo" style={{ height: 30, display: 'block' }} />
            </div>

            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: "12px" }}>
                <BalanceDisplay />
                <AccountPopover />
            </div>
        </div>
    ), [lgUp, onOpenNav]);

    return (
        <Layout.Header style={{
            position: 'fixed',
            top: 0,
            height: 60,
            display: 'flex',
            alignItems: 'center',
            padding: '0 16px',
            borderBottom: '1px solid #E6E6E6',
            width: '100%', background: '#fff', zIndex: 999
        }}>
            {renderContent}
        </Layout.Header>
    );
}

Header.propTypes = {
    onOpenNav: PropTypes.func,
};
